export default "data:image/webp;base64,UklGRjIAAABXRUJQVlA4TCUAAAAvJ4AGACDMNhIZz/kbnUKfApJki/+hiwkEEp1ch77/WZj/zBMzAA=="